<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type { UndoAction } from '@/shared/utils/notify'
import UpdateBanner from './UpdateBanner.vue'

const { t } = useI18n()

function run(message: { data?: UndoAction }, close: () => void): void {
  close()
  message.data?.undo()
}
</script>

<template>
  <RouterView />
  <Toast position="top-center" />
  <!-- Удаление в корзину без подтверждения, но с отменой (ТЗ 14.1). -->
  <Toast position="bottom-center" group="undo" class="undo-toast">
    <template #container="{ message, closeCallback }">
      <div class="undo-toast__body" role="status">
        <span class="undo-toast__text">{{ message.summary }}</span>
        <Button
          :label="message.data?.label ?? t('common.undo')"
          text
          size="small"
          class="undo-toast__action"
          @click="run(message, closeCallback)"
        />
      </div>
    </template>
  </Toast>
  <ConfirmDialog :breakpoints="{ '575px': '100vw' }" />
  <UpdateBanner />
</template>

<style>
/* На телефоне уведомление не шире экрана (по умолчанию у PrimeVue 25rem). */
.p-toast {
  width: min(25rem, calc(100vw - 2rem));
}
.undo-toast {
  max-width: calc(100vw - 2rem);
  margin-bottom: calc(4.5rem + env(safe-area-inset-bottom));
}
@media (min-width: 960px) {
  .undo-toast {
    margin-bottom: 1rem;
  }
}
.undo-toast__body {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 0.5rem 0.5rem 1rem;
  border-radius: 12px;
  background: var(--p-surface-800);
  color: var(--p-surface-0);
}
.undo-toast__text {
  flex: 1;
  min-width: 0;
}
.undo-toast__action.p-button {
  color: var(--p-primary-200);
  min-height: 44px;
  font-weight: 600;
}
:root.app-dark .undo-toast__action.p-button {
  color: var(--p-primary-color);
}
</style>
